"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['color', 'backgroundColor', 'borderColor'];
exports.default = _default;